import axios from 'axios'

export const getRating = (rateId) => {
    return new Promise((res, rej) => {
        axios.get(process.env.REACT_APP_API_URL + "/api/v1/rides/bookingRate", {//159.89.236.159
            params: {
                id: rateId
            }
        }).then((result) => {
            res(result)
        }).catch(err => {
            res(false)
            console.log(err)
        })
    })
}

export const setRating = (rateId, rating) => {
    return new Promise((res, rej) => {
        axios.post(process.env.REACT_APP_API_URL + "/api/v1/rides/bookingRate", {//159.89.236.159
            data: {
                id: rateId,
                rating: rating
            }
        }).then((result) => {
            res(result)
        }).catch(err => {
            res(false)
            console.log(err)
        })
    })
}